module.exports = __webpack_public_path__ + "img/Assessment.7830533c.jpg";